import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=f737b83c&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=f737b83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f737b83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f737b83c')) {
      api.createRecord('f737b83c', component.options)
    } else {
      api.reload('f737b83c', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=f737b83c&scoped=true&", function () {
      api.rerender('f737b83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/calendar/Edit.vue"
export default component.exports